import React, { FC, useEffect } from "react";
import Heading from "components/Heading/Heading";
import Glide from "@glidejs/glide";
import { TierDataTaxonomy } from "data/types";
import ncNanoId from "utils/ncNanoId";
import NextPrev from "shared/NextPrev/NextPrev";

export interface SectionTierCardSliderProps {
    className?: string;
    itemClassName?: string;
    categories?: TierDataTaxonomy[];
    itemPerRow?: 1 | 2 | 3;
    sliderStyle?: "style1" | "style2";
}
const DEMO_CATS: TierDataTaxonomy[] = [];
const SectionTierCardSlider: FC<SectionTierCardSliderProps> = ({
    className = "",
    itemClassName = "",
    categories = [],
    itemPerRow = 1,
    sliderStyle = "style1",
}) => {
    const UNIQUE_CLASS = "glide_" + ncNanoId();
    useEffect(() => {
        if (document.querySelector(`.${UNIQUE_CLASS}`)) {
            new Glide(`.${UNIQUE_CLASS}`, {
                perView: itemPerRow,
                gap: 16,
                focusAt : 'center',
                peek : {before : 0, after : window.innerWidth * 0.04,},
                bound: true,
                breakpoints: {
                    1280: {
                        perView: itemPerRow - 1,
                    },
                    1024: {
                        gap: 20,
                        perView: itemPerRow - 1,
                    },
                    768: {
                        gap: 20,
                        perView: itemPerRow - 2,
                    },
                    640: {
                        gap: 20,
                        perView: itemPerRow - 3,
                    },
                    500: {
                        gap: 20,
                        perView: 1.3,
                    },
                },
            }).mount();
        }
    }, [UNIQUE_CLASS, categories]);
    return (
        <div className={`nc-SectionTierCardSlider ${className}`}>
            <div className={`${UNIQUE_CLASS} flow-root`}>
                <div className="glide__track" data-glide-el="track">
                    <ul className="glide__slides">
                        {categories.map((item, index) => (
                            <li key={index} className={`glide__slide ${itemClassName}`}>
                                {/* {renderCard(item, index)} */}

                                <div className="tire-card">
                                    <div>
                                        <img src={item.tier_image}></img>
                                        <div className="level"><i className=" las la-star"></i> Lv. 222</div>
                                        <div className="mb-10 reward-card">
                                     
                                    
                                    <div className="progress-bar">
                                        <div className={`progress-fill`}  style={{ width: `${10}%` }}></div> {/* Dynamic progress */}
                                    </div>
                                    <div className="progress-text">
                                        <span>11/ 1499</span>
                                        <span>2</span>
                                    </div>
                                    </div>
                                    </div>
                                </div>

                            </li>
                        ))}
                    </ul>
                </div>
                {/* {categories.length > 2 && <NextPrev className="justify-center" />} */}
            </div>
        </div>
    );
};

export default SectionTierCardSlider;
